import Cookies from 'js-cookie';

import { DISCOUNT_API_URL } from '../constants';

const fetchDiscountDetails = async (discountCode) => {
  const response = await fetch(DISCOUNT_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ discountCode }),
  });
  const data = await response.json();

  return data;
};

const fetchDiscount = async () => {
  const discountCode = Cookies.get('discount_code');

  if (!discountCode) {
    return;
  }

  // Check the cookies for the discount code
  const discountCodeKey = `discount_${discountCode}_v2`;
  const discountDetails = Cookies.get(discountCodeKey);
  if (discountDetails) {
    return JSON.parse(discountDetails);
  }

  // Fetch the discount details from the API
  const discount = await fetchDiscountDetails(discountCode);
  if (discount) {
    Cookies.set(discountCodeKey, JSON.stringify(discount), { expires: 3 });
    return discount;
  }

  return null;
};

(async () => {
  const discount = await fetchDiscount();
  if (discount) {
    document.body.dispatchEvent(new CustomEvent('discount:change', { detail: discount }));
  }
})();
